export var SubscriptionFeeSubType;
(function (SubscriptionFeeSubType) {
    SubscriptionFeeSubType["RATE"] = "RATE";
    SubscriptionFeeSubType["VOLUME"] = "VOLUME";
})(SubscriptionFeeSubType || (SubscriptionFeeSubType = {}));
